import {APIService, type InstanceApi} from 'services/api/api';
import type {LangType, MessagesType} from 'src/lib/translates/types'
import {
  DeleteRiddleResponse,
  type CreateRiddle,
  type CreateRiddleResponse,
} from './entities';

class ServiceRiddles {

  api: InstanceApi | null = null;

  public init(messages?: MessagesType) {
    const api = new APIService({messages})
    this.api = api.getInstanse()
  }

  private createRiddleUrl() {
    return `/riddles`
  }

  private deleteRiddleUrl(id: string) {
    return `${this.createRiddleUrl()}/${id}`
  }

  public getRiddlesJsonUrl(lang: LangType) {
    return `${this.api?.defaults.baseURL}${this.createRiddleUrl()}/${lang}`
  }

  public createRiddle = async (body: CreateRiddle): Promise<CreateRiddleResponse> => {        
    if (this.api) {
        try {
          const response = await this.api.post<CreateRiddleResponse>(
            this.createRiddleUrl(),
            body,
          )

          return response.data
        } catch (error) {
          console.log('RestApiServiceRiddles.createRiddle: ' + JSON.stringify(error))
          throw Error(error as string)
        }
    }
    throw Error('RestApiServiceRiddles.createRiddle: axios is broken')
  }
  
  public updateRiddle = async (riddleId: string, body: Partial<CreateRiddle>): Promise<void> => {
    if (this.api) {
        try {
          return await this.api.put(
            this.deleteRiddleUrl(riddleId),
            body,
          )
        } catch (error) {
          console.log('RestApiServiceRiddles.updateRiddle: ' + JSON.stringify(error))
          throw Error(error as string)
        }
    }
    throw Error('RestApiServiceRiddles.updateRiddle: axios is broken')
  }

  public deleteRiddle = async (riddleId: string): Promise<DeleteRiddleResponse> => {        
    if (this.api) {
        try {
          const response = await this.api.delete<DeleteRiddleResponse>(
            this.deleteRiddleUrl(riddleId),
          )

          return response.data
        } catch (error) {
          console.log('RestApiServiceRiddles.deleteRiddle: ' + JSON.stringify(error))
          throw Error(error as string)
        }
    }
    throw Error('RestApiServiceRiddles.deleteRiddle: axios is broken')
  }
}

export const serviceRiddles = new ServiceRiddles();
